import { useEffect } from "react";
import { toast } from "@/hooks/use-toast";

export function UpdateToast() {
  useEffect(() => {
    function handleUpdateAvailable() {
      toast({
        title: "Update available",
        description: "A new version of Kintsugi is ready.",
        duration: Infinity,
        action: (
          <button
            onClick={() => window.location.reload()}
            className="rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-white hover:bg-primary/90 transition-colors"
          >
            Reload
          </button>
        ),
      });
    }

    function handleOfflineReady() {
      toast({
        title: "Ready for offline use",
        description: "Kintsugi is installed and works without internet.",
        duration: 4000,
      });
    }

    window.addEventListener("pwa-update-available", handleUpdateAvailable);
    window.addEventListener("pwa-offline-ready", handleOfflineReady);

    return () => {
      window.removeEventListener("pwa-update-available", handleUpdateAvailable);
      window.removeEventListener("pwa-offline-ready", handleOfflineReady);
    };
  }, []);

  return null;
}
